import React, { useState, useEffect } from "react";
import './Signup.css';
import { useNavigate } from 'react-router-dom';

import user_icon from '../Assets/person.png';
import email_icon from '../Assets/email.png';
import password_icon from '../Assets/password.png';

const Signup = ({ onLogin }) => {
  const [action, setAction] = useState("Login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const hasVisitedInfo = localStorage.getItem("visitedInformation");
    if (!hasVisitedInfo) {
      navigate("/information");
    }
  }, [navigate]);

  const validateInputs = () => {
    if (action === "Sign Up" && name.trim() === "") {
      setError("Name is required.");
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Invalid email format.");
      return false;
    }
    if (password.length < 8) {
      setError("Password must be at least 8 characters long.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateInputs()) return;

    setIsLoading(true); // Tampilkan loading saat proses berlangsung
    try {
      if (action === "Login") {
        // Login request
        const response = await fetch('https://freddway-v2.credibug.com/api/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email, password }),
        });

        const data = await response.json();

        if (response.ok) {
          // Simpan token dan role ke localStorage jika login berhasil
          localStorage.setItem('token', data.token);
          localStorage.setItem('role', data.user.role);
          onLogin();
          navigate('/dashboard');
        } else {
          setError(data.message || "Invalid credentials.");
        }
      } else {
        // Sign Up request
        // const response = await fetch('https://freddway-v2.credibug.com/api/signup', {
        const response = await fetch('https://freddway-v2.credibug.com/api/signup', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ name, email, password }),
        });

        const data = await response.json();

        if (response.ok) {
          setName("");
          setEmail("");
          setPassword("");
          setAction("Login");
          setError("User registered successfully! Please log in.");
        } else {
          setError(data.message || "Failed to sign up.");
        }
      }
    } catch (err) {
      setError("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading(false); // Sembunyikan loading saat selesai
    }
  };

  const switchAction = () => {
    setAction(action === "Login" ? "Sign Up" : "Login");
    setName("");
    setEmail("");
    setPassword("");
    setError("");
  };

  return (
    <div className="container">
      <div className="header">
        <div className="text">{action}</div>
        <div className="underline"></div>
      </div>
      <div className="inputs">
        {action === "Sign Up" && (
          <div className="input">
            <img src={user_icon} alt="" />
            <input
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        )}
        <div className="input">
          <img src={email_icon} alt="" />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="input">
          <img src={password_icon} alt="" />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
      </div>
      {error && <div className="error-message">{error}</div>}
      <div className="submit-container">
        <div
          className="submit"
          onClick={!isLoading ? handleSubmit : null}
          style={{
            opacity: isLoading ? 0.7 : 1,
            cursor: isLoading ? 'not-allowed' : 'pointer',
          }}
        >
          {isLoading ? "Processing..." : action}
        </div>
      </div>
      <div className="switch-container">
        <div className="switch" onClick={switchAction}>
          {action === "Login" ? (
            <>Don't have an account? <span style={{ color: '#2980b9', cursor: 'pointer' }}>Sign Up</span></>
          ) : (
            <>Already have an account? <span style={{ color: '#2980b9', cursor: 'pointer' }}>Login</span></>
          )}
        </div>
      </div>
    </div>
  );
};

export default Signup;
